// import React from 'react';

// const TopCategoriesTabs = () => {
//   const categories = [
//     { name: 'Men', bgColor: 'bg-yellow-400' },
//     { name: 'Women', bgColor: 'bg-blue-500' },
//     { name: 'Kids', bgColor: 'bg-white' },
//     { name: 'others', bgColor: 'bg-white' }
//   ];

//   return (
//     <div className="flex justify-center items-center py-4 bg-gray-100">
//       <div className="flex gap-2">
//         {categories.map((category, index) => (
//           <button
//             key={index}
//             className={`px-6 py-2 rounded-md text-sm font-medium ${
//               category.bgColor
//             } ${
//               category.bgColor === 'bg-white' 
//                 ? 'text-gray-700 hover:bg-gray-50' 
//                 : 'text-white hover:opacity-90'
//             } transition-all duration-200`}
//           >
//             {category.name}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default TopCategoriesTabs;
// import React, { useState, useRef, useEffect } from 'react';

// const TopCategoriesTabs = () => {
//   const [activeTab, setActiveTab] = useState('Women');
//   const scrollContainerRef = useRef(null);
//   const [showLeftArrow, setShowLeftArrow] = useState(false);
//   const [showRightArrow, setShowRightArrow] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [isOverflowing, setIsOverflowing] = useState(false);

//   const categories = [
//     'Men',
//     'Women',
//     'Kids',
//     'others',
//     // 'Accessories',
//     // 'Beauty',
//     // 'Home & Living',
//     // 'Electronics',
//     // 'Sports',
//     // 'Books'
//   ];

//   // Detect mobile
//   useEffect(() => {
//     const checkMobile = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   // Check if content overflows and scroll position
//   const checkOverflowAndScroll = () => {
//     if (scrollContainerRef.current) {
//       const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
//       const hasOverflow = scrollWidth > clientWidth;

//       setIsOverflowing(hasOverflow);

//       // Only show arrows if content overflows
//       if (hasOverflow) {
//         setShowLeftArrow(scrollLeft > 0);
//         setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
//       } else {
//         setShowLeftArrow(false);
//         setShowRightArrow(false);
//       }
//     }
//   };

//   useEffect(() => {
//     checkOverflowAndScroll();

//     // Check on window resize
//     window.addEventListener('resize', checkOverflowAndScroll);

//     // Check on scroll
//     const scrollContainer = scrollContainerRef.current;
//     if (scrollContainer) {
//       scrollContainer.addEventListener('scroll', checkOverflowAndScroll);
//     }

//     // Use ResizeObserver to detect content changes
//     const resizeObserver = new ResizeObserver(checkOverflowAndScroll);
//     if (scrollContainer) {
//       resizeObserver.observe(scrollContainer);
//     }

//     return () => {
//       window.removeEventListener('resize', checkOverflowAndScroll);
//       if (scrollContainer) {
//         scrollContainer.removeEventListener('scroll', checkOverflowAndScroll);
//       }
//       if (resizeObserver && scrollContainer) {
//         resizeObserver.unobserve(scrollContainer);
//       }
//     };
//   }, [categories.length]); // Re-run when categories change

//   const scroll = (direction) => {
//     if (scrollContainerRef.current) {
//       const scrollAmount = isMobile ? 100 : 200;
//       const currentScroll = scrollContainerRef.current.scrollLeft;
//       scrollContainerRef.current.scrollTo({
//         left: direction === 'left' 
//           ? currentScroll - scrollAmount 
//           : currentScroll + scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   return (
//     <div className="w-full sticky top-0 z-50 bg-white">
//       <div className="relative">
//         {/* Left Arrow - Only show if content overflows and not on mobile */}
//         {!isMobile && isOverflowing && showLeftArrow && (
//           <button
//             onClick={() => scroll('left')}
//             className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-r-md p-2 hover:bg-gray-100 transition-colors"
//           >
//             <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//             </svg>
//           </button>
//         )}

//         {/* Right Arrow - Only show if content overflows and not on mobile */}
//         {!isMobile && isOverflowing && showRightArrow && (
//           <button
//             onClick={() => scroll('right')}
//             className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-l-md p-2 hover:bg-gray-100 transition-colors"
//           >
//             <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//             </svg>
//           </button>
//         )}

//         {/* Tabs Container */}
//         <div
//           ref={scrollContainerRef}
//           className={`
//             flex items-center justify-center
//             ${isMobile ? 'gap-6 px-4 py-1' : 'gap-12 px-8 py-2'} 
//             ${isOverflowing ? 'overflow-x-auto' : 'overflow-hidden'}
//             scrollbar-hide scroll-smooth
//           `}
//           style={{
//             msOverflowStyle: 'none',
//             scrollbarWidth: 'none',
//             WebkitScrollbar: { display: 'none' }
//           }}
//         >
//           {categories.map((category) => (
//             <button
//               key={category}
//               onClick={() => setActiveTab(category)}
//               className={`
//                 ${isMobile ? 'px-4 py-1.5 text-xs' : 'px-6 py-2 text-sm'} 
//                 rounded-md font-medium whitespace-nowrap
//                 transition-all duration-300 min-w-fit
//                 ${activeTab === category 
//                   ? 'bg-[#007BFF] text-white shadow-md transform scale-105' 
//                   : 'bg-white text-gray-700 hover:bg-gray-100'
//                 }
//               `}
//               style={{
//                 backgroundColor: activeTab === category ? '#007BFF' : undefined
//               }}
//             >
//               {category}
//             </button>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TopCategoriesTabs;


// import React, { useState, useRef, useEffect } from "react";
// import api from "../../common/apiClient";
// import SummaryAPI from "../../common/SummaryApi";

// const TopCategoriesTabs = ({ activeCategory, onCategoryChange }) => {
//   const scrollContainerRef = useRef(null);

//   const [categories, setCategories] = useState([]);
//   // const [activeTab, setActiveTab] = useState("");
//   const [loading, setLoading] = useState(true);

//   const [showLeftArrow, setShowLeftArrow] = useState(false);
//   const [showRightArrow, setShowRightArrow] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [isOverflowing, setIsOverflowing] = useState(false);

//   /* ---------------------- Fetch Top Categories ---------------------- */
//   useEffect(() => {
//     const fetchTopCategories = async () => {
//       try {
//         const res = await api({
//           method: SummaryAPI.getAllTopCategories.method,
//           url: SummaryAPI.getAllTopCategories.url
//         });

//         const visibleCategories = res.data.data.filter(
//           (cat) => !cat.hidetopCategory
//         );

//         setCategories(visibleCategories);

//         // Set default active tab
//         // if (visibleCategories.length > 0) {
//         //   setActiveTab(visibleCategories[0].name);
//         // }
//         // if (visibleCategories.length > 0) {
//         //   const womenCategory = visibleCategories.find(
//         //     (cat) => cat.name.toLowerCase() === "women"
//         //   );

//         //   setActiveTab(womenCategory ? womenCategory.name : visibleCategories[0].name);
//         // }

//       } catch (error) {
//         console.error("Failed to fetch top categories", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTopCategories();
//   }, []);

//   /* ---------------------- Detect Mobile ---------------------- */
//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth < 768);
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   /* ---------------------- Scroll Handling ---------------------- */
//   const checkOverflowAndScroll = () => {
//     if (!scrollContainerRef.current) return;

//     const { scrollLeft, scrollWidth, clientWidth } =
//       scrollContainerRef.current;

//     const hasOverflow = scrollWidth > clientWidth;
//     setIsOverflowing(hasOverflow);

//     if (hasOverflow) {
//       setShowLeftArrow(scrollLeft > 0);
//       setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
//     } else {
//       setShowLeftArrow(false);
//       setShowRightArrow(false);
//     }
//   };

//   useEffect(() => {
//     checkOverflowAndScroll();

//     window.addEventListener("resize", checkOverflowAndScroll);
//     const container = scrollContainerRef.current;

//     if (container) {
//       container.addEventListener("scroll", checkOverflowAndScroll);
//     }

//     return () => {
//       window.removeEventListener("resize", checkOverflowAndScroll);
//       if (container) {
//         container.removeEventListener("scroll", checkOverflowAndScroll);
//       }
//     };
//   }, [categories]);

//   const scroll = (direction) => {
//     if (!scrollContainerRef.current) return;

//     const scrollAmount = isMobile ? 100 : 200;
//     const currentScroll = scrollContainerRef.current.scrollLeft;

//     scrollContainerRef.current.scrollTo({
//       left:
//         direction === "left"
//           ? currentScroll - scrollAmount
//           : currentScroll + scrollAmount,
//       behavior: "smooth"
//     });
//   };

//   if (loading) return null;

//   return (
//     <div className="w-full sticky top-0 z-50 bg-white">
//       <div className="relative">

//         {/* Left Arrow */}
//         {!isMobile && isOverflowing && showLeftArrow && (
//           <button
//             onClick={() => scroll("left")}
//             className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-r-md p-2"
//           >
//             ◀
//           </button>
//         )}

//         {/* Tabs */}
//         <div
//           ref={scrollContainerRef}
//           className={`flex items-center justify-center
//             ${isMobile ? "gap-6 px-4 py-1" : "gap-12 px-8 py-2"}
//             ${isOverflowing ? "overflow-x-auto" : "overflow-hidden"}
//             scrollbar-hide`}
//         >
//           {categories.map((category) => (
//             <button
//               key={category._id}
//               onClick={() => onCategoryChange(category.name.toLowerCase())}
//               className={`
//                 ${activeCategory === category.name.toLowerCase()
//                   ? "bg-[#007BFF] text-white shadow-md scale-105"
//                   : "bg-white text-gray-700 hover:bg-gray-100"
//                 }
//               `}
//             >
//               {category.name}
//             </button>
//           ))}
//         </div>

//         {/* Right Arrow */}
//         {!isMobile && isOverflowing && showRightArrow && (
//           <button
//             onClick={() => scroll("right")}
//             className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-l-md p-2"
//           >
//             ▶
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default TopCategoriesTabs;

// import React, { useRef, useEffect, useState, useMemo } from "react";
// import api from "../../common/apiClient";
// import SummaryAPI from "../../common/SummaryApi";
// import CategoryMegaMenu from "./CategoryMegaMenu";


// const TopCategoriesTabs = ({ activeCategory, onCategoryChange }) => {
//   const scrollContainerRef = useRef(null);

//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [hoverCategory, setHoverCategory] = useState(null);
//   const [subCategories, setSubCategories] = useState([]);


//   const [showLeftArrow, setShowLeftArrow] = useState(false);
//   const [showRightArrow, setShowRightArrow] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [isOverflowing, setIsOverflowing] = useState(false);

//   /* ---------------- Fetch Top Categories ---------------- */
//   useEffect(() => {
//     const fetchTopCategories = async () => {
//       try {
//         const res = await api({
//           method: SummaryAPI.getAllTopCategories.method,
//           url: SummaryAPI.getAllTopCategories.url,
//         });

//         const visible = res.data.data.filter(
//           (cat) => !cat.hidetopCategory
//         );

//         console.log("Fetched Top Categories:", visible);

//         setCategories(visible);
//       } catch (err) {
//         console.error("Failed to fetch categories", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTopCategories();
//   }, []);

//   useEffect(() => {
//     const fetchSubCategories = async () => {
//       try {
//         const res = await api({
//           method: SummaryAPI.getAllSubCategories.method,
//           url: SummaryAPI.getAllSubCategories.url
//         });

//         const visible = res.data.data.filter(
//           (sub) => !sub.hidesubCategory
//         );

//         setSubCategories(visible);
//       } catch (err) {
//         console.error("Failed to fetch sub categories", err);
//       }
//     };

//     fetchSubCategories();
//   }, []);


//   /* ---------------- Normalize active category ---------------- */
//   const normalizedActiveCategory = useMemo(() => {
//     if (!categories.length) return null;

//     const match = categories.find(
//       (cat) => cat.name.toLowerCase() === activeCategory
//     );

//     return match ? match.name.toLowerCase() : null;
//   }, [categories, activeCategory]);

//   /* ---------------- Mobile Detect ---------------- */
//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth < 768);
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   /* ---------------- Scroll Handling ---------------- */
//   const checkOverflowAndScroll = () => {
//     if (!scrollContainerRef.current) return;

//     const { scrollLeft, scrollWidth, clientWidth } =
//       scrollContainerRef.current;

//     const overflow = scrollWidth > clientWidth;
//     setIsOverflowing(overflow);

//     if (overflow) {
//       setShowLeftArrow(scrollLeft > 0);
//       setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
//     } else {
//       setShowLeftArrow(false);
//       setShowRightArrow(false);
//     }
//   };

//   useEffect(() => {
//     checkOverflowAndScroll();
//     window.addEventListener("resize", checkOverflowAndScroll);

//     const el = scrollContainerRef.current;
//     if (el) el.addEventListener("scroll", checkOverflowAndScroll);

//     return () => {
//       window.removeEventListener("resize", checkOverflowAndScroll);
//       if (el) el.removeEventListener("scroll", checkOverflowAndScroll);
//     };
//   }, [categories]);

//   if (loading || !normalizedActiveCategory) return null;

//   return (
//     <div className="w-full sticky top-0 z-30 bg-white" onMouseLeave={() => setHoverCategory(null)}>
//       <div className="relative">
//         {!isMobile && isOverflowing && showLeftArrow && (
//           <button
//             onClick={() =>
//               scrollContainerRef.current.scrollBy({
//                 left: -200,
//                 behavior: "smooth",
//               })
//             }
//             className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow p-2 z-10"
//           >
//             ◀
//           </button>
//         )}

//         <div
//           ref={scrollContainerRef}
//           className={`flex justify-center items-center gap-8 px-6 py-2 ${isOverflowing ? "overflow-x-auto" : "overflow-hidden"
//             }`}
//         >
//           {categories.map((cat) => {
//             const slug = cat.name.toLowerCase();
//             const isActive = normalizedActiveCategory === slug;

//             return (
//               <button
//                 key={cat._id}
//                 onClick={() => onCategoryChange(slug)}
//                 onMouseEnter={() => !isMobile && setHoverCategory(slug)}
//                 className={`px-6 py-2 text-sm font-medium rounded-md transition-all
//                   ${isActive
//                     ? "bg-[#007BFF] text-white shadow scale-105"
//                     : "text-gray-700 hover:bg-gray-100"
//                   }
//                 `}
//               >
//                 {cat.name}
//               </button>
//             );
//           })}
//         </div>

//         {!isMobile && isOverflowing && showRightArrow && (
//           <button
//             onClick={() =>
//               scrollContainerRef.current.scrollBy({
//                 left: 200,
//                 behavior: "smooth",
//               })
//             }
//             className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow p-2 z-10"
//           >
//             ▶
//           </button>
//         )}
//         {/* MEGA MENU */}
//         {!isMobile && (
//           <CategoryMegaMenu
//             category={hoverCategory}
//             isOpen={!!hoverCategory}
//             subCategories={subCategories}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default TopCategoriesTabs;



// import React, { useRef, useEffect, useState, useMemo } from "react";
// import api from "../../common/apiClient";
// import SummaryAPI from "../../common/SummaryApi";
// import CategoryMegaMenu from "./CategoryMegaMenu";

// const TopCategoriesTabs = ({ activeCategory, onCategoryChange }) => {
//   const scrollContainerRef = useRef(null);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [hoverCategory, setHoverCategory] = useState(null);
//   const [subCategories, setSubCategories] = useState([]);
//   const [isMobile, setIsMobile] = useState(false);
//   const SHOW_MEGA_MENU = false;

//   // Fetch Categories logic stays same...
//   useEffect(() => {
//     const fetchTopCategories = async () => {
//       try {
//         const res = await api({
//           method: SummaryAPI.getAllTopCategories.method,
//           url: SummaryAPI.getAllTopCategories.url,
//         });
//         const visible = res.data.data.filter((cat) => !cat.hidetopCategory);
//         // setCategories(visible);
//         const sorted = [...visible].sort((a, b) =>
//           a.name.localeCompare(b.name)
//         );

//         setCategories(sorted);
//       } catch (err) {
//         console.error("Failed to fetch categories", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchTopCategories();
//   }, []);

//   useEffect(() => {
//     const fetchSubCategories = async () => {
//       try {
//         const res = await api({
//           method: SummaryAPI.getAllSubCategories.method,
//           url: SummaryAPI.getAllSubCategories.url
//         });
//         const visible = res.data.data.filter((sub) => !sub.hidesubCategory);
//         setSubCategories(visible);
//       } catch (err) {
//         console.error("Failed to fetch sub categories", err);
//       }
//     };
//     fetchSubCategories();
//   }, []);

//   // const normalizedActiveCategory = useMemo(() => {
//   //   if (!categories.length) return null;
//   //   const match = categories.find((cat) => cat.name.toLowerCase() === activeCategory);
//   //   return match ? match.name.toLowerCase() : null;
//   // }, [categories, activeCategory]);

//   const normalizedActiveCategory = useMemo(() => {
//     if (!activeCategory) return null;
//     return activeCategory.toLowerCase();
//   }, [activeCategory]);

//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth < 768);
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   // if (loading || !normalizedActiveCategory) return null;
//   if (loading) return null;

//   return (
//     <div
//       className="w-full sticky top-[76px] z-40 bg-white shadow-sm"
//       onMouseLeave={() => setHoverCategory(null)}
//     >
//       <div className="relative max-w-screen-2xl mx-auto">
//         {/* CATEGORY TABS */}
//         <div
//           ref={scrollContainerRef}
//           className={`
//             flex items-center gap-4 md:gap-8 px-4 py-3
//             overflow-x-auto scroll-smooth
//             [&::-webkit-scrollbar]:hidden
//             [-ms-overflow-style:none] [scrollbar-width:none]
//             ${isMobile ? "justify-start" : "justify-center"}
//           `}
//         >
//           {categories.map((cat) => {
//             const slug = cat.name.toLowerCase();
//             const isActive =
//               normalizedActiveCategory === slug;

//             return (
//               <button
//                 key={cat._id}
//                 onClick={() => onCategoryChange(slug)}
//                 onMouseEnter={() =>
//                   !isMobile && setHoverCategory(slug)
//                 }
//                 className={`
//                   px-5 py-2 text-sm font-semibold rounded-lg
//                   transition-all flex-shrink-0 whitespace-nowrap
//                   ${
//                     isActive
//                       ? "bg-[#007BFF] text-white shadow-md scale-105"
//                       : "text-gray-600 hover:bg-gray-100 hover:text-black"
//                   }
//                 `}
//               >
//                 {cat.name}
//               </button>
//             );
//           })}
//         </div>

//         {/* OPTIONAL MEGA MENU */}
//         {SHOW_MEGA_MENU && !isMobile && (
//           <CategoryMegaMenu
//             category={hoverCategory}
//             isOpen={!!hoverCategory}
//             subCategories={subCategories}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default TopCategoriesTabs;


import React, { useRef, useEffect, useState, useMemo } from "react";
import api from "../../common/apiClient";
import SummaryAPI from "../../common/SummaryApi";
import CategoryMegaMenu from "./CategoryMegaMenu";

/* FIXED DISPLAY ORDER (FRONTEND ONLY) */
const CATEGORY_ORDER = ["men", "women", "kids", "others"];

const TopCategoriesTabs = ({ activeCategory, onCategoryChange }) => {
  const scrollContainerRef = useRef(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hoverCategory, setHoverCategory] = useState(null);
  const [subCategories, setSubCategories] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const SHOW_MEGA_MENU = false;

  /* ---------------- FETCH TOP CATEGORIES ---------------- */
  useEffect(() => {
    const fetchTopCategories = async () => {
      try {
        const res = await api({
          method: SummaryAPI.getAllTopCategories.method,
          url: SummaryAPI.getAllTopCategories.url,
        });

        const visible = res.data.data.filter(
          (cat) => !cat.hidetopCategory
        );

        /* ✅ FRONTEND SORT ONLY */
        const sorted = [...visible].sort((a, b) => {
          const aIndex = CATEGORY_ORDER.indexOf(a.name.toLowerCase());
          const bIndex = CATEGORY_ORDER.indexOf(b.name.toLowerCase());

          if (aIndex === -1 && bIndex === -1) return 0;
          if (aIndex === -1) return 1;
          if (bIndex === -1) return -1;

          return aIndex - bIndex;
        });

        setCategories(sorted);
      } catch (err) {
        console.error("Failed to fetch categories", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTopCategories();
  }, []);

  /* ---------------- FETCH SUB CATEGORIES ---------------- */
  useEffect(() => {
    const fetchSubCategories = async () => {
      try {
        const res = await api({
          method: SummaryAPI.getAllSubCategories.method,
          url: SummaryAPI.getAllSubCategories.url
        });
        const visible = res.data.data.filter(
          (sub) => !sub.hidesubCategory
        );
        setSubCategories(visible);
      } catch (err) {
        console.error("Failed to fetch sub categories", err);
      }
    };
    fetchSubCategories();
  }, []);

  const normalizedActiveCategory = useMemo(() => {
    if (!categories.length) return null;
    const match = categories.find(
      (cat) => cat.name.toLowerCase() === activeCategory
    );
    return match ? match.name.toLowerCase() : null;
  }, [categories, activeCategory]);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  if (loading || !normalizedActiveCategory) return null;

  return (
    <div
      className="w-full sticky top-[67px] md:top-[66px] lg:top-[67px]
                 z-40 bg-white shadow-sm"
      onMouseLeave={() => setHoverCategory(null)}
    >
      <div className="relative max-w-screen-2xl mx-auto">
        <div
          ref={scrollContainerRef}
          className={`
            flex items-center gap-4 md:gap-8 px-4 py-3
            overflow-x-auto scroll-smooth
            [&::-webkit-scrollbar]:hidden
            [-ms-overflow-style:none] [scrollbar-width:none]
            ${isMobile ? "justify-start" : "justify-center"}
          `}
        >
          {categories.map((cat) => {
            const slug = cat.name.toLowerCase();
            const isActive = normalizedActiveCategory === slug;

            return (
              <button
                key={cat._id}
                onClick={() => onCategoryChange(slug)}
                onMouseEnter={() => !isMobile && setHoverCategory(slug)}
                className={`
                  px-5 py-2 text-sm font-semibold rounded-lg
                  transition-all flex-shrink-0 whitespace-nowrap
                  ${isActive
                    ? "bg-[#007BFF] text-white shadow-md scale-105"
                    : "text-gray-600 hover:bg-gray-100 hover:text-black"}
                `}
              >
                {cat.name}
              </button>
            );
          })}
        </div>

        {SHOW_MEGA_MENU && !isMobile && (
          <CategoryMegaMenu
            category={hoverCategory}
            isOpen={!!hoverCategory}
            subCategories={subCategories}
          />
        )}
      </div>
    </div>
  );
};

export default TopCategoriesTabs;
